<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-vue-next'

interface Props {
  class?: HTMLAttributes['class']
  /** Title displayed in the header */
  title?: string
  /** Whether to show the close button */
  showClose?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showClose: true
})

defineSlots<{
  icon(): any
  actions(): any
  default(): any
}>()

const emit = defineEmits<{
  close: []
}>()
</script>

<template>
  <div
    :class="cn(
      'flex items-center justify-between px-4 py-3 border-b border-border',
      props.class
    )"
  >
    <div class="flex items-center gap-2">
      <slot name="icon" />
      <span class="text-sm font-medium">{{ title }}</span>
    </div>
    <div class="flex items-center gap-2">
      <slot name="actions" />
      <Button
        v-if="showClose"
        variant="ghost"
        size="icon"
        class="h-7 w-7"
        @click.stop="emit('close')"
      >
        <X class="h-4 w-4" />
      </Button>
    </div>
  </div>
</template>
